import React, {InputHTMLAttributes} from 'react';
import classnames from 'classnames';
import styles from './InputCheckbox.module.scss';

export interface InputComponentProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value'> {
  id: string,
  value: boolean,
  label?: React.ReactNode,
  error?: string,
  touched?: boolean,
  customClassNames?: Partial<{
    checkBoxContainer: string,
    inputContainer: string
  }>
}

const InputCheckbox = ({
                         label,
                         value,
                         error,
                         touched,
                         customClassNames,
                         ...rest
                       }: InputComponentProps) => {
  return (
    <label className={classnames(styles.inputContainer, customClassNames?.inputContainer)}>
      <div className={classnames(styles.checkboxContainer, customClassNames?.checkBoxContainer)}>
        <input
          className={styles.input}
          type="checkbox"
          {...rest}
        />
        <div className={classnames(styles.checkbox, {
          [styles.checked]: value,
          [styles.error]: error && touched
        })}/>
        <div className={styles.labelContainer}>
          {label}
        </div>
      </div>
    </label>
  );
};

export default InputCheckbox;
